import { useContext } from 'react';
import { useStore } from 'zustand/index';

import { MappingFormatterContext, MappingFormatterState } from './mappingFormatterStore';

export function useMappingFormatterStore<T>(selector: (state: MappingFormatterState) => T): T {
  const store = useContext(MappingFormatterContext);
  if (!store) throw new Error('Missing MappingFormatterContext.Provider in the tree');
  return useStore(store, selector);
}
